import { environment } from '../config/environment';
import { useApiClient } from './api';

export interface EmailResponse {
    success: boolean;
    message: string;
    details?: any;
}

export const useTransactionalEmailService = () => {
    const apiClient = useApiClient();
    const baseUrl = `${environment.expressApiUrl}/api/transactional-email`;

    /**
     * Send a password reset email
     * @param email Email address to send the reset link to
     */
    const sendPasswordReset = async (email: string): Promise<EmailResponse> => {
        const response = await apiClient.post(`${baseUrl}/password-reset?email=${encodeURIComponent(email)}`);
        return response.data;
    };

    /**
     * Send an email confirmation
     * @param email Email address to send the confirmation to
     */
    const sendEmailConfirmation = async (email: string): Promise<EmailResponse> => {
        const response = await apiClient.post(`${baseUrl}/confirm-email`, { email });
        return response.data;
    };

    /**
     * Send an email confirmation
     */
    const sendEmailChange = async (email: string, newEmail: string): Promise<EmailResponse> => {
        const response = await apiClient.post(`${baseUrl}/change-email`, { email, newEmail });
        return response.data;
    };

    /**
     * Send a welcome email
     * @param email Email address to send the welcome email to
     */
    const sendWelcomeEmail = async (email: string): Promise<EmailResponse> => {
        const response = await apiClient.get(`${baseUrl}/welcome-email?email=${encodeURIComponent(email)}`);
        return response.data;
    };

    const sendPurchaseSucceedEmail = async (details: any): Promise<EmailResponse> => {
        const response = await apiClient.post(`${baseUrl}/purchase-succeed`, {
            details
        });
        return response.data;
    };

    return {
        sendPasswordReset,
        sendEmailConfirmation,
        sendEmailChange,
        sendWelcomeEmail,
        sendPurchaseSucceedEmail,
    };
};
